const accordions = document.querySelectorAll('.block--accordion')
const contentBoxes = []
window.dataLayer = window.dataLayer || []
accordions.forEach(a => {
    const items = a.querySelectorAll('.accordion-item')
    items.forEach(item => {
        const input = item.querySelector('input')
        const content = item.querySelector('.tab-content')
        contentBoxes.push(content)
        input.addEventListener('click', e => {
            if (e.target.checked) {
                content.style.maxHeight = `${content.scrollHeight}px`
            } else {
                content.style.maxHeight = 0;
            }
            window.dataLayer.push({
                'event': 'accordion',
                'accordion_item': e.target.parentNode.querySelector('h3').innerText
            })
        })

    })
})

window.addEventListener('resize', e => {
    contentBoxes.forEach(box => {
        const newHeight = `${box.scrollHeight}px`
        if (box.offsetHeight > 0 && box.style.maxHeight !== newHeight) {
            box.style.maxHeight = newHeight
        }
    })
})